/* eslint-disable max-len */
import { Kitchen } from '@rta/rta-blueprint-library';
import { Document, Font, Image, Page, Text, View } from '@react-pdf/renderer';

import { EstimateAssemblyCost } from './estimate-assembly-cost';
import { EstimateDocumentHeader } from './estimate-document-header';
import { EstimateItemized } from './estimate-itemized-table';
import { fontConfig } from '../font-config';
import logoMain from '@assets/logo/logo-main.png';
import { styleSheet } from '../style-sheet';
import { CustomerState, ProjectState } from '@state';

Font.register(fontConfig);

export type EstimateDocumentProps = {
	data: {
		customer: CustomerState;
		project: ProjectState;
		tax: number;
		kitchen: Kitchen | null;
		image: string | null;
	};
}
// Create Document Component
export const EstimateDocument = (props: EstimateDocumentProps) => {
	const { customer, kitchen, project, tax, image } = props.data;

	if (!customer || !kitchen || !project) return null;

	return (<>
		<Document>
			<Page size="LETTER" style={styleSheet.page}>
				<Image src={logoMain} style={styleSheet.logo} />
				<Text style={styleSheet.documentTitle}>{customer?.firstName} {customer?.lastName}</Text>
				<Text style={styleSheet.documentTitle}>Outdoor Kitchen Quote</Text>
				<EstimateDocumentHeader data={{ customer, kitchen, project }} />
				<View style={styleSheet.body}>
					<EstimateItemized data={{ kitchen, tax }} />
					<EstimateAssemblyCost data={{ kitchen }} />
					<View style={styleSheet.terms}>
						<Text style={styleSheet.heading}>Purchase terms</Text>
						<View style={styleSheet.bulletList}>
							<View style={styleSheet.listItem}>
								<Text style={styleSheet.bulletPoint}>•</Text>
								<Text style={styleSheet.listItemText}>This estimate is only for the items listed above. Installation and Assembly not included.</Text>
							</View>
							<View style={styleSheet.listItem}>
								<Text style={styleSheet.bulletPoint}>•</Text>
								<Text style={styleSheet.listItemText}>All discounts / sales are applied to the kitchen, appliances themselves are not discounted.</Text>
							</View>
							<View style={styleSheet.listItem}>
								<Text style={styleSheet.bulletPoint}>•</Text>
								<Text style={styleSheet.listItemText}>Deposits are fully refundable all the way up until blueprints are started (refer to deposit form for full deposit details)</Text>
							</View>
							<View style={styleSheet.listItem}>
								<Text style={styleSheet.bulletPoint}>•</Text>
								<Text style={styleSheet.listItemText}>If sales tax is not included on this order but you live in a state with sales tax, it will either be collected by RTA at the same time of shipping, or must be paid to the state directly by the consumer.</Text>
							</View>
							<View style={styleSheet.listItem}>
								<Text style={styleSheet.bulletPoint}>•</Text>
								<Text style={styleSheet.listItemText}>Promotions apply to complete outdoor kitchen packages (kitchen + appliances). Orders that include only a kitchen without appliances may not qualify for the full promotion and could be subject to adjustments.</Text>
							</View>
						</View>

						<Text style={[styleSheet.heading, styleSheet.marginTop]}>Consumer/End Product User&apos;s Right To Cancel</Text>
						<Text style={styleSheet.text}>
							RTA Outdoor Living complies with all federal, state, and local laws of the area in which they conduct business. In the event that a buyer exercises his or her right to cancel a sale, RTA Outdoor Living will replace the product for the Distributor, pursuant to RTA Outdoor Living return policies. Orders for appliances or for standard outdoor kitchens/fire features may be canceled WITH written notice prior to shipment with no cancellation fee. Given the high cost to ship these items, after Coyote appliances or standard outdoor kitchens/fire features have been shipped, but prior to delivery, these items will be subject to a 20% cancellation fee. Since custom outdoor kitchens/fire features have limited resale value, once a custom outdoor kitchen/fire feature blueprint has been approved, these orders will be subject to a 30% cancellation fee, which increases by an additional 15% if the order has already shipped.
						</Text>
					</View>
				</View>
			</Page>
			<Page size="LETTER" style={styleSheet.page}>
				<Image src={logoMain} style={styleSheet.logo} />
				{ image && <Image src={image} style={styleSheet.estimateBPImage} /> }
			</Page>
		</Document>
	</>);
};
